import {useContext, useState} from "react";
import {LoadingContext, ToastContext, UserContext} from "../../contexts";
import {NotificacaoApi} from "../../apis";

export const NotificacaoEditor = ({item, update, key}) => {
  const {user} = useContext(UserContext);
  const [modalDelete, setModalDelete] = useState(false);
  const {setLoading} = useContext(LoadingContext);

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const deleteItem = async () => {
    setLoading(true);
    try {
      let respostaDelete = await NotificacaoApi.delete(user.uuid, item.uuid);
      if (!respostaDelete.error) {
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
        update();
        setLoading(false);
      } else {
        AddToast({texto: respostaDelete.error, tipo: "erro"});
        setLoading(false);
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
    setModalDelete(false);
  }

  return (
    <div className="arquivo" key={key}>
      <div className="arquivo-item">
        <div className="publicacao-info">
          <span className="data">{item.data}</span>
          <span className="titulo">{item.texto}</span>
        </div>
        <div className="opcoes">
          <div className="btn btn-primary" onClick={() => setModalDelete(true)}>
            Excluir
          </div>
        </div>
      </div>

      {modalDelete &&
        <div className="modal-delete">
          <div className="delete-box">
            <span>Tem certeza que deseja remover o arquivo?</span>
            <div className="button" onClick={deleteItem}>
              Sim
            </div>
            <div className="button" onClick={() => setModalDelete(false)}>
              Não
            </div>
          </div>
        </div>
      }
    </div>
  );
}